import { getRequest } from '../utils'

export interface ResultsValidityResponse {
  partially_valid: boolean
  fully_valid: boolean
  node_states: Record<string, string>
}

export const getResultsValid: RequestTypeVariable = {
  getKey: (projectId: string) => ['getResultsValid', projectId],
  request: async (projectId): Promise<ResultsValidityResponse | null> => {
    const { data } = await getRequest<ResultsValidityResponse>({
      url: `/projects/${projectId}/results/valid`,
    })
    return data
  },
}

export const getHorizontalForcesPerSegment: RequestTypeVariable = {
  getKey: (id: string) => ['getHorizontalForcesPerSegment', id],
  request: async (projectId): Promise<SegmentForces[] | null> => {
    const { data } = await getRequest<SegmentForces[]>({
      url: `/projects/${projectId}/horizontal-forces-per-segment`,
    })

    return data
  },
}

export const getLoadsPerElement: RequestTypeVariable = {
  getKey: (id: string) => ['getLoadsPerElement', id],
  request: async (projectId, signal: AbortSignal): Promise<ElementLoad[] | null> => {
    const { data } = await getRequest<ElementLoad[]>({
      url: `/projects/${projectId}/loads-per-element`,
      signal,
    })

    return data
  },
}

export const getAnchorInterventionTableData: RequestTypeVariable = {
  getKey: (projectId: string) => ['getAnchorInterventionTableData', projectId],
  request: async (id, signal: AbortSignal): Promise<AnchorInterventionsTableRowData[]> => {
    const { data } = await getRequest<AnchorInterventionsTableRowData[]>({
      url: `/projects/${id}/anchor-interventions-table-data`,
      signal,
    })

    return data as AnchorInterventionsTableRowData[]
  },
}
